export interface OrderCommentCommand {
  comment: string;
}
